// 作品数据
export const operatingWorksData=[{
    id:1,
    data:[6,6,6,7,6,2,4]
},{
    id:2,
    data:[4.6,6.5,27.5,16.8,4.6,2,1.8]
},{
    id:3,
    data:[16.94,15.67,24.19,22.59,17.34,15.44,17.23]
},{
    id:4,
    data:[0.86,0.53,0.3,0.31,0.8,0.83,2.32]
},{
    id:5,
    data:[294,266,572,350,267,128,236,]
},{
    id:6,
    data:[8152,5905,6043,8745,8105,6613,4975]
},{
    id:7,
    data:[0,0,0,0,0,0,0,]
},{
    id:8,
    data:[8.56,5.83,2.35,3.78,7.72,12.93,10.74]
},{
    id:9,
    data:[0,0,0,0,0,0,0,]
},]
// 粉丝数据
export const operatingFanData=[
    {   
        id:1,
        data:[7022,7027,7063,7074,7078,7080,7081]
    },
    {   
        id:2,
        data:[6,5,36,11,4,2,1]
    },  {   
        id:3,
        data:[17,13,21,15,14,15,11]
    },
    {   
        id:4,
        data:[719,582,2857,1412,393,245,175]
    },
    {   
        id:5,
        data:[25,15,18,27,31,14,9]
    },
]
// 收入数据
export const incomeData=[
    {id:1,data:[36.6,0,36.9,36.9,8,0,0]},
    {id:2,data:[0,0,0,0,0,0,0]},
    {id:3,data:[36.6,0,36.9,36.9,8,0,0]},
]
// 直播数据
export const liveData=[
    {id:1,data:[0,0,0,0,0,0,0]},
    {id:2,data:[0,0,0,0,0,0,0]},
    {id:3,data:[0,0,0,0,0,0,0]},
    {id:4,data:[0,0,0,0,0,0,0]},
    {id:5,data:[]},
    
]
// 作品数据详情
// 流量数据
export const flowData=[
    {
        id:1,
        flowData:[
            {
                id:1,
                data:[1702,33000,238000,145000,11000,543,353]
            },
            {
                id:2,
                data:[3,24,277,222,11,0,0]
            },
            {
                id:3,
                data:[1,0,13,14,1,0,0]
            },
            {
                id:4,
                data:[1,4,112,96,10,0,2]
            },
            {
                id:5,
                data:[0,5,46,27,1,1,0]
            },
            {
                id:6,
                data:[0,0,0,0,0,0,0]
            },
            {
                id:7,
                data:[99.42,16.54,20.98,22.09,22.08,22.09,22.09]
            },
            {
                id:8,
                data:[40.11,43.53,37.72,36.47,36.48,36.48,36.48]
            },
        ]
},
    {
        id:2,
        flowData:[
            {
                id:1,
                data:[334,43,36,21,13,3,10]
            },
            {
                id:2,
                data:[0,0,0,1,0,0,0]
            },
            {
                id:3,
                data:[0,0,0,0,0,0,0]
            },
            {
                id:4,
                data:[0,0,0,0,0,0,0]
            },
            {
                id:5,
                data:[0,0,0,0,0,0,0]
            },
            {
                id:6,
                data:[0,0,0,0,0,0,0]
            },
            {
                id:7,
                data:[11.86,11.85,11.86,11.86,11.85,11.85,11.86]
            },
            {
                id:8,
                data:[35.89,35.91,35.92,35.93,35.94,35.94,35.94]
            },
        ]
}
]
// 粉丝
export const FanWorkData=[
 {
    id:1,
    fansData:[
        {id:1,data:[0,4,16,11,2,1,0]},
        {id:2,data:[0,2,4,5,1,0,0]},
        {id:3,data:[1.25,0.6,0.15,0.11,0.11,0.11,0.11]},
    ]
 },
 {
    id:2,
    fansData:[
        {id:1,data:[0,0,0,0,0,0,0]},
        {id:2,data:[0,0,0,0,0,0,0]},
        {id:3,data:[1.27,1.32,1.34,1.34,1.34,1.35,1.37]},
    ]
 }
]
// 观众分析
export const AudienceAnalysisData=[
    {
        id:2,
        analysisData:[
            {id:1,data:[0,4,16,11,2,1,0]},
            {id:2,data:[0,0.01,0.01,0.01,0.01,0.01,0.01]},
            {id:3,data:[0,2,4,5,1,0,0]},
            {id:4,data:[0.01,0.02,0.03,0.03,0.03,0.03,0.03]},
            {id:5,data:[0,17,143,82,10,1,0]},
            {id:6,data:[0.02,0.04,0.06,0.06,0.06,0.06,0.06]},
        ]
    },
    {
        id:2,
        analysisData:[
            {id:1,data:[0,0,0,0,0,0,0]},
            {id:2,data:[0.08,0.08,0.08,0.08,0.08,0.08,0.08]},
            {id:3,data:[0,0,0,0,0,0,0]},
            {id:4,data:[0.01,0.01,0.01,0.01,0.01,0.01,0.01]},
            {id:5,data:[0,0,0,0,0,0,0]},
            {id:6,data:[0.24,0.24,0.24,0.24,0.24,0.24,0.24]},
        ]
    }

]
// 观众偏好
export const AudiencePreference=[
    {
        id:1,//彩椒
        data:[
            {
                id:1, //全部
                xData:["随拍","时尚","舞蹈","未分类","美食","二次元","明星"],
                y1Data:[62.74,7.17,5.19,5,3.21,2.26,1.98],
                y2Data:[1450.7,222.9,189.9,127.5,89.4,78.3,70.9],

            },
            {
                id:2,//粉丝
                xData:["旅行"],
                y1Data:[100],
                y2Data:[3547.1],
            }
        ]
    },
    {
        id:2,//姐妹
        data:[
            {
                id:1, //全部
                xData:["汽车","随拍","美食"],
                y1Data:[33.33,33.33,33.33],
                y2Data:[1112.3,770.8,929],

            },
            {
                id:2,//粉丝
                xData:[],
                y1Data:[],
                y2Data:[],
            }
        ]
    }
]
// 观众喜欢/关注的同类作者
export const AudienceLove=[
    {id:1,
    data:[
        {
            name:"李蠕蠕",
            url:require("../../../assets/img/audienceAvator/imgage1/img1.png"),
            fansData:"2470.3万"
        },
        {
            name:"方圆",
            url:require("../../../assets/img/audienceAvator/imgage1/img2.png"),
            fansData:"925.2万"
        },
        {
            name:"炫迈妹子i",
            url:require("../../../assets/img/audienceAvator/imgage1/img3.png"),
            fansData:"983.9万"
        },
        {
            name:"白鹿my",
            url:require("../../../assets/img/audienceAvator/imgage1/img4.png"),
            fansData:"3229.5万"
        },
    ]},
    {id:2,
        data:[
            {
                name:"方圆",
                url:require("../../../assets/img/audienceAvator/imgage1/img2.png"),
                fansData:"925.2万"
            },
            {
                name:"白鹿my",
                url:require("../../../assets/img/audienceAvator/imgage1/img4.png"),
                fansData:"3229.5万"
            },
            {
                name:"iiiis",
                url:require("../../../assets/img/audienceAvator/imgage1/img5.png"),
                fansData:"1098万"
            },
            {
                name:"疯狂小杨哥",
                url:require("../../../assets/img/audienceAvator/imgage1/img6.png"),
                fansData:"1.09亿"
            },
        ]}
]
// 观众常搜的热搜词
export const trendingSearch=[
    {
        id:1,
        data:[
            {
                title:"哪吒2",
                value:"2506.8万",
                url:require("../../../assets/img/auAnalysis/img1.png"),
            },  {
                title:"哪吒2票房实时数据",
                value:"5996.1万",
                url:require("../../../assets/img/auAnalysis/img2.png"),
            },  {
                title:"哪吒2实时票房",
                value:"2379.8万",
                url:require("../../../assets/img/auAnalysis/img3.png"),
            },  {
                title:"哪吒2魔童闹海",
                value:"2253.4万",
                url:require("../../../assets/img/auAnalysis/img4.png"),
            },  {
                title:"哪吒",
                value:"1650.8万",
                url:require("../../../assets/img/auAnalysis/img5.png"),
            },
        ]
    },
    {
        id:2,
        data:[
            {
                title:"哪吒2票房实时数据",
                value:"7121.6万",
                url:require("../../../assets/img/audienceAnalysis4/img1.png"),
            },  {
                title:"哪吒2全球票房",
                value:"2029.3万",
                url:require("../../../assets/img/audienceAnalysis4/img2.png"),
            },  {
                title:"哪吒2",
                value:"2493.1万",
                url:require("../../../assets/img/audienceAnalysis4/img3.png"),
            },  {
                title:"哪吒之魔童闹海",
                value:"1490.5万",
                url:require("../../../assets/img/audienceAnalysis4/img4.png"),
            },  {
                title:"李明德",
                value:"1195.8万",
                url:require("../../../assets/img/audienceAnalysis4/img5.png"),
            },
        ]
    },
]
// 观众喜欢的话题
export const AudienceTopic=[
    {
        id:1,
        data:[
            {
                title:"元宵节",
                playValue:"40.59亿",
                hotValue:"4486.3万",
                url:require("../../../assets/img/audienceTopic/image1/img1.png"),
                img:require("../../../assets/img/audienceTopic/image1/url1.png"),
            },  {
                title:"哪吒2",
                playValue:"62.18亿",
                hotValue:"5007.4万",
                url:require("../../../assets/img/audienceTopic/image1/img2.png"),
                img:require("../../../assets/img/audienceTopic/image1/url2.png"),
            },  {
                title:"娱乐评论打赏",
                playValue:"62.18亿",
                hotValue:"5007.4万",
                url:require("../../../assets/img/audienceTopic/image1/img3.png"),
                img:require("../../../assets/img/audienceTopic/image1/url3.png"),
            },  {
                title:"情人节",
                playValue:"64.4亿",
                hotValue:"1.02亿",
                url:require("../../../assets/img/audienceTopic/image1/img4.png"),
                img:require("../../../assets/img/audienceTopic/image1/url4.png"),
            },  {
                title:"真实还原",
                playValue:"29.95亿",
                hotValue:"6182.9万",
                url:require("../../../assets/img/audienceTopic/image1/img5.png"),
                img:require("../../../assets/img/audienceTopic/image1/url5.png"),
            },
        ]
    },
    {
        id:2,
        data:[
            {
                title:"万万想不到",
                playValue:"25.93亿",
                hotValue:"4096万",
                url:require("../../../assets/img/audienceTopic/image2/img1.png"),
                img:require("../../../assets/img/audienceTopic/image2/url1.png"),
            },  {
                title:"抖出健康知识宝藏",
                playValue:"43.74亿",
                hotValue:"4105.5万",
                url:require("../../../assets/img/audienceTopic/image2/img2.png"),
                img:require("../../../assets/img/audienceTopic/image2/url2.png"),
            },  {
                title:"开学",
                playValue:"16.06亿",
                hotValue:"5723万",
                url:require("../../../assets/img/audienceTopic/image2/img3.png"),
                img:require("../../../assets/img/audienceTopic/image2/url3.png"),
            },  {
                title:"元宵节",
                playValue:"40.59亿",
                hotValue:"4486.3万",
                url:require("../../../assets/img/audienceTopic/image2/img4.png"),
                img:require("../../../assets/img/audienceTopic/image2/url4.png"),
            },  {
                title:"哪吒2",
                playValue:"62.18亿",
                hotValue:"5007.4万",
                url:require("../../../assets/img/audienceTopic/image2/img5.png"),
                img:require("../../../assets/img/audienceTopic/image2/url5.png"),
            },
        ]
    },
]
// 观众画像 观众区域
export const  spectatorArea=[
{
    id:1, //全部
    xData:["广东","河南","江苏","四川","浙江","山东","湖南"],
    y1Data:[8.36,7.19,5.92,5.92,5.82,4.94,4.62],
    y2Data:[99.2,85.2,93,109.1,130.4,77.6,105.2],
},
{
    id:2,//姐妹
    xData:["广东","浙江","江苏","山东","河南","福建","湖北"],
    y1Data:[11.23,10.22,7.26,5.39,5.29,4.73,4.61],
    y2Data:[133.3,228.8,114.1,84.7,62.6,167.9,109.5],
}]
// 观众城市等级
export const  audienceCityClass=[  
{
    id:1, //全部
    xData:["一线","新一线","二线","三线","四线","五线","六线"],
    y1Data:[8.3,16.77,15.8,24.11,19.56,14.46,0.92],
    y2Data:[151.5,114.3,104.9,90.5,93.3,93.3,98.1],
},
{
    id:2,//姐妹
    xData:["一线","新一线","二线","三线","四线","五线","六线"],
    y1Data:[9.46,21.34,20.97,21.88,16.19,9.08,0.99],
    y2Data:[172.6,145.5,139.1,82.2,77.2,58.6,106.5],
}]
// 观众年龄
export const AudienceAge=[  
    {
        id:1, //全部
        xData:["18岁以下","18-23","24-30","31-40","41-50","50以上"],
        y1Data:[16.54,53.29,24.51,4.85,0.49,0.32],
        y2Data:[511.8,296.4,128.1,16.1,3.2,2.3],
    },
    {
        id:2,//姐妹
        xData:["18岁以下","18-23","24-30","31-40","41-50","50以上"],
        y1Data:[17.86,44.43,27,9.08,0.94,0.69],
        y2Data:[552.5,247.1,141.1,30.1,6.2,4.9],
}]
// 粉丝数据-粉丝分析--基础数据
export const fansBasicsData=[
    {
        id:1,
        data:[6,5,36,11,4,1,2]
    },
    {
        id:2,
        data:[17,13,21,15,14,15,11]
    },
    {
        id:3,
        data:[34,37,45,16,21,28,18]
    },
]
// 粉丝数据-粉丝分析--年龄
export const fansAge={
    xData:["<23", "24-30", "31-40", "41-50", ">50"],
    yData:[36, 15, 31, 6, 12]
}
// 粉丝数据-粉丝分析--城市
export const fansCity={
    xData:["广东", "江苏", "山东", "浙江", "河南", "福建", "河北", "四川", "上海", "湖南", "安徽", "湖北", "辽宁", "北京", "陕西", "广西", "山西", "云南", "重庆", "内蒙古", "黑龙江", "天津", "吉林", "贵州", "新疆", "甘肃", "海南"],
    yData:[11, 9, 7, 7, 5, 5, 4, 4, 4, 4, 4, 4, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1]
}
// 粉丝数据-粉丝分析--设备
export const equipment={
    xData: ["苹果", "华为", "UNKNOWN", "VIVO", "OPPO", "荣耀", "小米", "红米", "华为荣耀", "IQOO", "一加", "三星"],
    yData:[30, 14, 14, 11, 11, 7, 5, 3, 2, 1, 1, 1]
}


// 粉丝兴趣-兴趣分布
export const fansInterestDistribution={
    xData:["随拍", "剧情", "二次元", "游戏", "亲子", "明星", "美食", "时尚", "舞蹈", "体育"],
    yData:[32, 11, 10, 9, 8, 7, 7, 7, 5, 4]
}
export const newFansInterestDistribution={
    xData:["随拍", "体育", "明星", "美食", "舞蹈", "二次元", "电视剧", "时尚", "情感", "社会时政", "游戏", "剧情", "音乐", "动物", "亲子", "医疗健康", "财经", "汽车", "教育校园", "综艺", "旅行", "电影", "职场", "科技", "人文"],
    yData:[27, 8, 8, 6, 5, 5, 5, 5, 4, 4, 4, 3, 3, 3, 2, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0]
}
export const runOfFansInterestDistribution={
    xData:["随拍", "体育", "明星", "美食", "舞蹈", "时尚", "电视剧", "二次元", "情感", "游戏", "情感", "社会时政", "剧情", "动物", "音乐", "亲子", "综艺", "职场", "医疗健康", "教育校园", "财经", "电影", "旅行", "科技", "人文"],
    yData:[27, 8, 8, 6, 5, 5, 5, 5, 4, 4, 4, 4, 3, 3, 3, 2, 1, 1, 1, 1, 1, 1, 1, 0, 0]
}


// 收入分析
export const incomeView={
    y1Data:[22.81, 36.36, 0, 36.94, 36.94, 8.08, 0],
    y2Data:[35.48, 6.23, 6.60, 5.47, 4.64, 5.05, 3.16]
}
//变现渠道
export const realizationChannel={
    xData:["电商带货", "站外播放", "团购带货", "其他"],
    y1Data:[141.40, 0, 0, 0],
    y2Data:[60.20, 0.01, 6.21, 50.80]
}
// 变现行业
export const liquidationIndustry={
    xData:["生活服务", "家居建材", "美妆", "其他"],
    y1Data:[0, 0, 0, 141.4],
    y2Data:[6.11, 1.03, 255.00, 277.62]
}

// 粉丝画像--新增粉丝
export const addFansAge={
    xData:["<23", "24-30", "31-40" ,">50"],
    y1Data:[36,15,31,12],
    y2Data:[27,27,43,3]
}

export const addFansCity={
    xData: ['广东', '江苏', '山东', '浙江', '河南', '福建', '河北', '四川', '上海', '湖南', '安徽', '湖北', '辽宁', '北京', 
        '陕西', '广西', '山西', '云南', '重庆', '内蒙古', '黑龙江', '天津', '吉林', '贵州', '新疆', '甘肃', '海南'
      ],
    y1Data: [24, 12, 12, 8, 8, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2],//新增
    y2Data:[12, 9, 7, 3, 3, 3, 5, 1, 7, 4, 2, 2, 5, 4, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1]//全部

}
export const addFandom={
    xData:['在校大学生', '白领', '非工作人员', '公务员', '服务业', '农林牧渔', '制造业', '快递，外卖', '餐饮行业'],
    y1Data:[25, 20, 15, 10, 10, 5, 5, 5, 5],
    y2Data:[2, 14, 17, 2, 16, 8, 15, 3, 5]
}
// 粉丝画像--流失粉丝
export const drainFansAge={
    xData:["<23", "24-30", "31-40", "41-50", ">50"],
    y1Data:[52,26,15,2,5],
    y2Data:[36,15,31,6,12]
}
export const drainFansCity={
    xData: ['广东', '江苏', '山东', '浙江', '河南', '福建', '河北', '四川', '上海', '湖南', '安徽', '湖北', '辽宁', '北京', 
        '陕西', '广西', '山西', '云南', '重庆', '内蒙古', '黑龙江', '天津', '吉林', '贵州', '新疆', '甘肃', '海南'
      ],
    y1Data: [9, 9, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 4, 4, 4, 2, 2, 2],//新增
    y2Data:[12, 7, 9, 3, 5, 3, 5, 1, 7, 4, 2, 2, 5, 4, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1]//全部

}
export const drainFandom={
    xData:['在校大学生', '白领', '非工作人员', '公务员', '服务业', '农林牧渔', '制造业', '快递，外卖', '餐饮行业'],
    y1Data:[32,23,12,10,12,9,3,5,5],
    y2Data:[2,17,16,2,15,14,5,3,5]
}
export const daysOfAttention={
    xData:[">1月","1-3月","≥12月"],
    yData:[26,61,13]
}
